'use strict';

var log = require('../../log/Log').channel('CallsController');

angular.module('inara')
.controller('CallsController', CallsController);

CallsController.$inject = ['$rootScope', '$scope', '$state', '$timeout',
                           'CallsService', 'ViewStateService', 
                           '$ionicScrollDelegate'];

function CallsController($rootScope, $scope, $state, $timeout, 
                         CallsService, ViewStateService, 
                         $ionicScrollDelegate) {
    var vm = this;

    vm.callsBarVisible = false;
    vm.getActiveCallCount = CallsService.getActiveCallCount;
    vm.getActiveCalls = CallsService.getActiveCalls;
    vm.hangupAllCalls = CallsService.hangupAllCalls;
    vm.showParticipants = showParticipants;
    vm.canDial = canDial;

    log.info('initializing');

    $scope.$on('$stateChangeSuccess', onStateChange);
    $rootScope.$on('CallsServiceActiveCallCountChanged', onActiveCallCountChanged);

    function onStateChange(event, toState, toParams, fromState, fromParams) {
        var inCallView = $state.current.name === ViewStateService.getInCallState();
        vm.callsBarVisible = vm.getActiveCallCount() > 0 && !inCallView;
        if (inCallView) scrollToTop();
    }

    function scrollToTop(shouldAnimate) {
        // timeout prevents scroll delegate use before element compilation
        $timeout(function() {
            if ($state.current.name === ViewStateService.getInCallState()) {
                $ionicScrollDelegate.$getByHandle('call-list-scroll').
                    scrollTop(shouldAnimate);
            }
        }, 400);
    }

    function onActiveCallCountChanged() {
        if (CallsService.getActiveCallCount() === 0 &&
            $state.current.name === ViewStateService.getInCallState()) {
            $state.go(ViewStateService.getNoCallState());
        } else if (CallsService.getActiveCallCount() > 0) {
            scrollToTop(true);            
        }
    }

    function showParticipants(call) {
        return call.$getParticipants().length > 0 &&
            (call.callExtendedState === null ||
            !angular.isDefined(call.callExtendedState));
    }

    function canDial(call) {
        return call.callState === 'connected' && call.canDial === true;
    }
}

module.exports = CallsController;
